export const convertPhoneNumbePrefixToNumber = p => parseInt(p.replace(/\D+/g, ''), 10)

export const phoneNumbePrefixValidationFunction = (phoneNumbePrefix, countries) => {
  const convertedNumber = convertPhoneNumbePrefixToNumber(phoneNumbePrefix)
  // eslint-disable-next-line
  return !countries.filter(c => convertedNumber === parseInt(c.country_phone_prefix), 10).length;
}
export default phoneNumbePrefixValidationFunction
// TO DELETE AT END OF PROJECT: This was the validation when had autocomplete